import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=1e65a8f8&scoped=true&"
import script from "./Lead.vue?vue&type=script&lang=ts&"
export * from "./Lead.vue?vue&type=script&lang=ts&"
import style0 from "./Lead.vue?vue&type=style&index=0&id=1e65a8f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65a8f8",
  null
  
)

export default component.exports